import formatRangeEndAmount from './formatRangeEndAmount';

/**
 * "$9.99 – $14.99", or one amount when the ends match or the range has a single
 * entry. Whole amounts drop their cents. Works on magnitudes, so a range stored
 * with a credit's sign reads the same as a debit's. Null for an empty range.
 */
export default function formatAmountRangeLabel(amountRange: string[], currencyCode?: string | null): string | null {
  const amounts = amountRange.map((amount) => Math.abs(Number(amount))).filter((amount) => Number.isFinite(amount));
  if (amounts.length === 0) {
    return null;
  }
  const min = Math.min(...amounts);
  const max = Math.max(...amounts);
  const low = formatRangeEndAmount(min, currencyCode);
  return min === max ? low : `${low} – ${formatRangeEndAmount(max, currencyCode)}`;
}
